import React from 'react';
import { StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';

type LoaderProps = {
	text?: string;
	containerStyle?: ViewStyle;
	textStyle?: TextStyle;
};

const Loader = ({ text = 'Loading...', containerStyle, textStyle }: LoaderProps) => {
	return (
		<View style={[styles.container, containerStyle]}>
			<Text style={[styles.text, textStyle]}>{text}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	text: {
		fontSize: 16,
		color: '#FFFFFF',
	},
});

export default Loader;
